import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';

export const colorSchemes = {
  visit: {
    background: unifiedPlatformColorPalette.lightBlue50,
    text: unifiedPlatformColorPalette.lightSecondaryDark,
  },

  sales: {
    background: unifiedPlatformColorPalette.lightGreen50,
    text: unifiedPlatformColorPalette.lightPrimaryDark,
  },

  plain: {
    background: unifiedPlatformColorPalette.gray100,
    text: unifiedPlatformColorPalette.lightTextPrimary,
  },
};
